import { useId } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const JiraIcon = (props: SvgIconProps) => {
  const gradientId = useId().replace(/:/g, '');
  const primaryGradientId = `jira-primary-gradient-${gradientId}`;
  const secondaryGradientId = `jira-secondary-gradient-${gradientId}`;

  return (
    <SvgIcon {...props}>
      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16.8778 3.48285H9.65625C9.65625 5.28285 11.1131 6.74035 12.9136 6.74035H14.2417V8.02566C14.2417 9.82566 15.6992 11.2832 17.4992 11.2832V4.10426C17.4991 3.93949 17.4336 3.7815 17.3171 3.66499C17.2006 3.54848 17.0426 3.48297 16.8778 3.48285Z"
          fill="#2684FF"
        />
        <path
          d="M13.2998 7.08284H6.07812C6.07812 8.88269 7.53516 10.3402 9.335 10.3402H10.6637V11.6255C10.6637 13.4255 12.1212 14.883 13.9212 14.883V7.70409C13.921 7.53936 13.8555 7.38145 13.739 7.26497C13.6225 7.14848 13.4646 7.08309 13.2998 7.08284Z"
          fill={`url(#${primaryGradientId})`}
        />
        <path
          d="M9.72172 10.6825H2.5C2.5 12.4832 3.95687 13.94 5.7575 13.94H7.08562V15.226C7.08562 17.026 8.54313 18.4829 10.343 18.4829V11.3046C10.3428 11.1398 10.2773 10.9818 10.1609 10.8652C10.0444 10.7487 9.88649 10.6829 9.72172 10.6825Z"
          fill={`url(#${secondaryGradientId})`}
        />
        <defs>
          <linearGradient
            id={primaryGradientId}
            x1="13.7709"
            y1="7.09097"
            x2="10.6984"
            y2="10.2591"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.176" stopColor="#0052CC" />
            <stop offset="1" stopColor="#2684FF" />
          </linearGradient>
          <linearGradient
            id={secondaryGradientId}
            x1="10.4006"
            y1="10.7104"
            x2="6.84813"
            y2="14.1666"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.176" stopColor="#0052CC" />
            <stop offset="1" stopColor="#2684FF" />
          </linearGradient>
        </defs>
      </svg>
    </SvgIcon>
  );
};
export default JiraIcon;
